import { axiosClient } from '../../clients/axios-client'
import type { DocumentSectionTree } from '../../types'
import type { FileStructureResponseDto, FileStructureSectionDto } from './dtos/file'
import { FileStructureResponseDtoSchema } from './dtos/file'

function transformStructureDtoToSectionTree(
  sectionDto: FileStructureSectionDto
): DocumentSectionTree {
  const { id, type, caption, children } = sectionDto

  return {
    id,
    type,
    title: caption ?? '',
    children: type === 'text' ? [] : children.map(transformStructureDtoToSectionTree),
  }
}

export async function getFileStructure(fileId: string) {
  try {
    const { data } = await axiosClient.get<FileStructureResponseDto>(
      `/filepool/files/${fileId}/structure`
    )

    const parsedData: FileStructureResponseDto = FileStructureResponseDtoSchema.parse(data)

    const response: DocumentSectionTree[] = parsedData.sections.map(
      (section: FileStructureSectionDto) => {
        return transformStructureDtoToSectionTree(section)
      }
    )

    return response
  } catch (error) {
    console.error(`Error getting file sections. File id: ${fileId}`, error)
    throw error
  }
}
